import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/announcement?${p}`);
  },
  create(data) {
    return api.post(`/api/v1/announcement`, data);
  },
  update(data) {
    return api.put(`/api/v1/announcement/${data.id}`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/announcement/${id}`);
  },
  createPole(data) {
    return api.post(`/api/v1/announcement/display`, data);
  },
};
